// blog30.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import "../allcss/blog18.css";
import blogImage from "../Asets/Blog.jpg"; 
import detailImg from "../Asets/blog3030.png"; 
import Header from "../components/header";
import Footer from "../components/footer";

const Blog30 = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <div className="blog-section">
        
        {/* Hero Section */}
        <div
          className="blog-hero"
          style={{ backgroundImage: `url(${blogImage})` }}
        >
          <div className="blog-overlay">
            <h1 className="blog-title">Our Blog</h1>
            <p className="breadcrumb">
              <span
                style={{ cursor: "pointer", color: "#fff" }}
                onClick={() => navigate("/")}
              >
                Home
              </span>
              <span> / Our Blog / Winter Morning Routine for Preschoolers</span>
            </p>
          </div>
        </div>

        {/* Blog Detail */}
        <div className="blog-container">
          <h2 className="section-title">
            Winter Morning Routine for Preschoolers | A Cozy Start to the Day
          </h2>
          <br />
          <div className="published-badge">Published on: 29 November 2025</div>
          <br />

          <img
            src={detailImg}
            alt="Winter Morning Routine for Preschoolers | A Cozy Start to the Day"
            className="blog-detail-img"
          />

          <div className="blog-detail-content">

            <p>
              As the temperature dips in Vadodara, leaving a warm, cozy bed becomes a challenge for all of us—
              especially our little ones! Winter mornings can be sluggish, and getting a preschooler ready when
              it’s chilly outside can sometimes feel like a struggle.
            </p>

            <p>
              However, with a little planning and a lot of warmth, you can turn the morning rush into a joyful ritual.
              At <strong>Red School House Vadodara</strong>, we love seeing happy, bundled-up faces arrive at our gates.
              Here are 5 tips to create a smooth, cozy winter morning routine for your preschooler.
            </p>

            <hr />

            <h3>1. Prep the Night Before (The Layering Game)</h3>
            <p>Winter dressing takes longer. To avoid the morning scramble, lay out clothes the night before.</p>
            <ul>
              <li>
                <strong>The Golden Rule:</strong> Dress them in layers — thermal inner or soft cotton tee, shirt, and sweater.
              </li>
              <li>
                <strong>Why?</strong> Mornings in Harni are cold, afternoons warmer. Layers help adjust temperature comfortably.
              </li>
            </ul>

            <hr />

            <h3>2. Wake Up with Warmth</h3>
            <p>Jumping out of a blanket into cold air is a shock! Make it gentle.</p>
            <ul>
              <li>Open the curtains or turn on a soft light 5 minutes before waking them.</li>
              <li>Cuddle under the blanket for 2 minutes before getting up—this fills their emotional cup.</li>
            </ul>

            <hr />

            <h3>3. A Warm "Fuel-Up" Breakfast</h3>
            <p>Switch from cold cereals to warm, nourishing foods.</p>
            <ul>
              <li>Warm oatmeal with nuts, steaming poha, or hot parathas.</li>
              <li>Warm turmeric milk or soaked almonds for immunity boosting during flu season.</li>
            </ul>

            <hr />

            <h3>4. Skincare is Essential</h3>
            <p>Winter air is harsh on delicate skin, causing dryness.</p>
            <ul>
              <li>Make moisturizing a fun ritual — let them put a tiny dot of cream on their nose!</li>
              <li>Apply lip balm to prevent chapped lips.</li>
            </ul>

            <hr />

            <h3>5. The "Bundle Up" Exit</h3>
            <p>Right before stepping out, make bundling up fun — like a race!</p>
            <ul>
              <li>Jackets, caps, warm socks — all must be snug.</li>
              <li>Ensure ears and head are covered to avoid cold breeze exposure.</li>
            </ul>

            <hr />

            <h3>A Warm Welcome Awaits at Red School House</h3>
            <p>
              At Red School House Vadodara, we ensure the warmth continues even after your child enters the school.
              Our classrooms are safe, cozy, and engaging — helping children forget the cold and enjoy learning happily.
            </p>

            <p><strong>Is your child ready for a winter of learning and fun?</strong></p>

            <hr />

            <h3>Contact Details</h3>
            <p>
              📍 <strong>Address:</strong> A-25, Castle White, Opp. Main Harni Water Tank,
              Harni Sama Link Road, Vadodara – 390008
              <br />
              📞 <strong>Mobile:</strong> <a href="tel:+917778851070">+91 77788 51070</a>
              <br />
              📧 <strong>Email:</strong>{" "}
              <a href="mailto:redschoolhousebaroda2025@gmail.com">redschoolhousebaroda2025@gmail.com</a>{" "}
              |{" "}
              <a href="mailto:redschoolhousebaroda@gmail.com">redschoolhousebaroda@gmail.com</a>
              <br />
              🌐 <strong>Website:</strong>{" "}
              <a
                href="https://redhouseschoolvadodara.in/"
                target="_blank"
                rel="noreferrer"
              >
                redhouseschoolvadodara.in
              </a>
              <br />
              📸 <strong>Instagram:</strong>{" "}
              <a
                href="https://www.instagram.com/redschoolhousebaroda/"
                target="_blank"
                rel="noreferrer"
              >
                @redschoolhousebaroda
              </a>
            </p>

            <p className="blog-tags">
              #WinterRoutine &nbsp;
              #PreschoolTips &nbsp;
              #RedSchoolHouseVadodara &nbsp;
              #BestPreschoolHarni &nbsp;
              #VadodaraParents
            </p>

            {/* Back Button */}
            <div className="back-to-blogs-btn-wrapper">
              <button
                className="back-to-blogs-btn"
                onClick={() => navigate("/blog")}
              >
                Go Back To Blogs
              </button>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Blog30;
